import { fromEvent } from 'rxjs/observable/fromEvent';
import { mapTo } from 'rxjs/operators/mapTo';
import { switchMap } from 'rxjs/operators/switchMap';
import { map } from 'rxjs/operators/map';
import { combineEpics } from 'redux-observable';
import { AvatarActionTypes, UploadAvatar, RemoveAvatar, SetGravatar, UploadAvatarActionTypes, RemoveAvatarActionTypes, SetGravatarActionTypes, updateAvatar } from '../actions/AvatarActions';
import { getUploadAvatarRequestStatus, getRemoveAvatarRequestStatus, getSetGravatarRequestStatus } from '../selectors/RequestStatusSelector';
import { getEmailHashFromCurrentUserProfile } from '../selectors/ProfileSelector';
import AvatarAPI from '../api/AvatarAPI';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import { RequestEpicDescriptor, requestEntity } from 'settings-ui-lib/utils/epics';
const uploadAvatar = requestEntity(new RequestEpicDescriptor({
  apiFunction: AvatarAPI.uploadAvatar,
  initiatingActionType: AvatarActionTypes.UPLOAD_AVATAR,
  requestStatusSelector: getUploadAvatarRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: UploadAvatar
}));
const removeAvatar = requestEntity(new RequestEpicDescriptor({
  apiFunction: AvatarAPI.removeAvatar,
  initiatingActionType: AvatarActionTypes.REMOVE_AVATAR,
  requestStatusSelector: getRemoveAvatarRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: RemoveAvatar
}));
const setGravatar = requestEntity(new RequestEpicDescriptor({
  apiFunction: AvatarAPI.setGravatar,
  initiatingActionType: AvatarActionTypes.SET_GRAVATAR,
  requestStatusSelector: getSetGravatarRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: SetGravatar
}));
function loadImage(state) {
  const updatedAt = new Date().getTime();
  const img = new Image();
  img.src = AvatarAPI.getAvatarUrl(getEmailHashFromCurrentUserProfile(state), {
    updatedAt
  });
  return fromEvent(img, 'load').pipe(mapTo(updatedAt));
}
function changeAvatar($action, {
  getState
}) {
  return $action.ofType(UploadAvatarActionTypes.SUCCESS, RemoveAvatarActionTypes.SUCCESS, SetGravatarActionTypes.SUCCESS).pipe(switchMap(() => loadImage(getState())), map(updatedAt => updateAvatar(updatedAt)));
}
export default combineEpics(uploadAvatar, removeAvatar, setGravatar, changeAvatar);